import { captureError } from '@otto-ec/global-resources/apm';
import { log } from '@shared/log.browser.ts';

/*                                                 */
const DEFAULT_LABELS = { team: 'reptile', service: 'dundee' };

function hasStringMessage(error: object): error is { message: string } {
    if (!('message' in error)) {
        return false;
    }

    const { message }: { message: unknown } = error;
    return typeof message === 'string';
}

export function toReportableError(error: unknown): Error {
    if (error instanceof Error) {
        return error;
    }

    if (typeof error === 'object' && error !== null && hasStringMessage(error)) {
        return new Error(error.message);
    }

    try {
        return new Error(JSON.stringify(error));
    } catch {
        return new Error(String(error));
    }
}

export function createApmErrorHandlerBrowser(scope: string): (error: unknown, reset: () => void) => void {
    return async function onerror(error: unknown, _reset: () => void) {
        log.scope(scope).error(error);
        captureError(toReportableError(error), DEFAULT_LABELS, { type: scope });
    };
}
